// extracted by mini-css-extract-plugin
export var scrollArea = "_mo-0";